import { io } from "socket.io-client";
const RAW = process.env.REACT_APP_API_URL || "";
const URL = RAW.trim().replace(/\/+$/, "");

// Create socket but don't auto-connect: App.js controls when to connect and
// sets the query params before connecting. This avoids immediate connections
// with stale query/auth and prevents duplicate reconnections during hot reloads.
const socket = io(URL, {
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  pingInterval: 25000,
  pingTimeout: 60000,
  auth: undefined,
});

export default socket;
